module.exports = __webpack_public_path__ + "static/media/Inventor Professional.961ba358.png";